import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/translations';
import { Button } from 'app/components/BasicButtons/Button';
import { downloadFile } from 'utils/url-utils';
import { useDispatch } from 'react-redux';
import { useAppSettingsSlice } from 'app/slice';

interface DownloadFileButonProps {
  id: string;
  name?: React.ReactNode;
}

export function DownloadFileButon(props: DownloadFileButonProps) {
  const { t } = useTranslation();
  const url = `/file.ashx?id=${props.id}&ap=true`;
  const [busy, setBusy] = React.useState(false);
  const dispatch = useDispatch();
  const { actions } = useAppSettingsSlice();
  const handleClick = React.useCallback(
    async event => {
      event.preventDefault();
      if (busy) {
        return;
      }
      setBusy(true);
      try {
        await downloadFile({ path: url });
        setBusy(false);
      } catch (error) {
        setBusy(false);
        dispatch(
          actions.addNotification({
            variant: 'error',
            message: t(translations.Error_FileNotAvailable),
          }),
        );
      }

      return false;
    },
    [actions, busy, dispatch, t, url],
  );
  return (
    <Button
      component={'a'}
      href={url}
      size="small"
      variant="text"
      onClick={handleClick}
      processing={busy}
      disabled={busy}
    >
      {props.name ?? t(translations.Download)}
    </Button>
  );
}
